import Authorization from "../../../../generics/authorization";
import FilterView from "./FilterView";
import { MFE_COMPONENT_IDS } from "../../../../utils/enums";
const xValue = 0;
const wValue = 12;

const pageProps = {
  filterDashlets: [{
    component: FilterView,
    name: "summary",
    layout: { x: xValue, y: 0, w: wValue, h: 6 }
  }],
  componentId: MFE_COMPONENT_IDS.APP_QOE_DETAILS
};
const Page = () => (<Authorization pageProps={pageProps} />);

export default Page;
